<template>
	<ColumnContainer class="FlowEditorColumnContainer">
		<FlowSelector></FlowSelector>
		<TriggerEditor :cards="triggers"></TriggerEditor>
		<ConditionEditor :cards="conditions"></ConditionEditor>
		<ActionEditor :cards="actions"></ActionEditor>
	</ColumnContainer>
</template>

<script>
	import { Component, Vue } from 'vue-property-decorator';
	import { Getter } from 'vuex-class';
	import Button from '../Button/index.vue';
	import Dialog from '../Dialog/index.vue';
	import ColumnContainer from '../ColumnContainer/index.vue';
	import FlowSelector from './FlowSelector/index.vue';
	import TriggerEditor from './TriggerEditor/index.vue';
	import ConditionEditor from './ConditionEditor/index.vue';
	import ActionEditor from './ActionEditor/index.vue';
	import KeyListenerView from '../KeyListenerView';

	@Component({
		components: {
			Button,
			Dialog,
			ColumnContainer,
			FlowSelector,
			TriggerEditor,
			ConditionEditor,
			ActionEditor
		},
	})
	export default class FlowEditor extends KeyListenerView {
		@Getter('api/homey/flow/selected') flow;

		get triggers() {
			if (!this.flow) return [];
			return [this.flow.trigger];
		}

		get conditions() {
			if (!this.flow) return [];
			console.log('conditions', this.flow.conditions);
			return this.flow.conditions;
		}

		get actions() {
			if (!this.flow) return [];
			return this.flow.actions;
		}

		_toLogin() {
			this.$router.push('login');
		}

		_toHomeySelect() {
			this.$router.push('homeys');
		}

		mounted() {
			//this.addKeyboardListener('LEFT', this.onLeft, 'Left');
			//this.addKeyboardListener('RIGHT', this.onRight, 'Right');
			this.addKeyboardListener('N', this.onNewFlow, 'New Flow');
			super.mounted();
		}

		destroyed() {
			super.destroyed();
		}

		onLeft() {
			console.log('left');
		}

		onRight() {
			console.log('right');
		}

		onNewFlow() {
			this.$router.push('/flow/create');
		}
	}
</script>

<style lang="scss">
</style>